import { QUERY_KEYS } from '../../../../../consts';
import { getQuoteRejectReasonsService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const getQuoteRejectReasonsAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.QUOTES.QUOTE_REJECT_REASONS,
  mutationFn: () => getQuoteRejectReasonsService,
});
